import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Checkbox, Form, Input, InputNumber, Modal, Select, Space, Spin, Table, Tooltip } from "antd";
import "./work_order_invoice.css";
import { IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { MdRefresh } from "react-icons/md";
import { FaPlusCircle } from "react-icons/fa";
import { withWorkOrderInvoice, TableListPartInvoice } from "../../../components/hoc_work_order_invoice";
import ListDataWorkOrder from "./list_data_work_order";

const WorkOrderInvoice: React.FC<any> = ({
    form,
    initialValues,
    columns,
    data,
    isModalVisible,
    showModal,
    handleCancel,
    handleNew,
    handleWorkOrderSelect,
    salesTopOptions,
    provinceOptions,
    regencyOptions,
    kecamatanOptions,
    kelurahanOptions,
    loadingProvinces,
    loadingRegencies,
    loadingKecamatans,
    loadingKelurahans,
    onChangeProvince,
    onChangeRegency,
    onChangeKecamatan,
    onChangeKelurahan,
    showContentBillTo,
    setShowContentBillTo,
    showContentTaxList,
    setShowContentTaxList,
    showContentTotal,
    setShowContentTotal,
    vatTransOptions,
    autosaveStatus,
    onValuesChange,
    selectedRowKeys,
    setSelectedRowKeys,
    onSelectChange,
    handleVoid,
    handleSubmit,
    handlePrintInvoice,
    isPrinting,
    isProcessing,
    isVoidRemarkVisible,
    setIsVoidRemarkVisible,
    voidRemark,
    setVoidRemark,
    submitVoidWithRemark,
    handleRefresh,
    isReportModalOpen,
    handleReportModalCancel
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Newbtn = FaPlusCircle as React.ComponentType<any>;
    const Refreshbtn = MdRefresh as React.ComponentType<any>;

    return (
        <div id="ivog" style={transformStyle}>
            {isProcessing && <Spin spinning={true} fullscreen tip="Processing Data..." />}
            <div className="gjs-grid-row" id="inmq">
                <div className="gjs-grid-column" id="i62l">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_invoice_work_order",
                                title: (
                                    <>
                                        <span>Data Work Order Invoice</span>
                                    </>
                                ),
                            },
                            {
                                title: "Work Order Invoice",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="iq2tv">
                <div className="gjs-grid-column" id="iba5">
                    <Button className="gr-button" onClick={handleNew} disabled={isProcessing}>
                        <Newbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button"
                        onClick={handleSubmit}
                        disabled={isProcessing || autosaveStatus === 'processing' || (form.getFieldValue('status') !== 'Draft' && form.getFieldValue('status') !== '1')}
                    >
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                    <Button className="gr-button"
                        onClick={handleVoid}
                        disabled={isProcessing || autosaveStatus === 'processing' || (form.getFieldValue('status') !== 'Draft' && form.getFieldValue('status') !== '1' && form.getFieldValue('status') !== 'Active' && form.getFieldValue('status') !== '22')}
                    >
                        <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Void
                    </Button>
                    <Button className="gr-button" onClick={handlePrintInvoice} loading={isPrinting} disabled={isProcessing || autosaveStatus === 'processing'}>
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                    <Button className="gr-button" onClick={handleRefresh} disabled={isProcessing || (form.getFieldValue('status') !== 'Draft' && form.getFieldValue('status') !== '1')}>
                        <Refreshbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Refresh Data
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="ij4m">
                <div className="gjs-grid-column" id="i3ul">
                    <Form
                        form={form}
                        layout="horizontal"
                        initialValues={initialValues}
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onValuesChange={onValuesChange}
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Trans ID"
                            name="trans_id"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Invoice No"
                            name="invoice_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Invoice Date"
                            name="invoice_date"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Due Date"
                            name="due_date"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Brand"
                            name="brand"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Work Order No"
                            style={{ marginBottom: "5px" }} >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item
                                    name="work_order_no"
                                    noStyle
                                    style={{ width: "100%" }}
                                    rules={[{ required: true, message: 'Work Order No. wajib diisi.' }]}
                                >
                                    <Input
                                        style={{ width: "100%" }}
                                        readOnly
                                    />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="list_data_work_order"
                                    disabled={isProcessing || !!form.getFieldValue('work_order_no')}
                                    onClick={showModal}
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Customer"
                            name="customer"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="No. Polisi"
                            name="no_polisi"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Chassis No"
                            name="chassis_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Service Advisor"
                            name="service_advisor"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Contact Service No"
                            name="contact_service_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="PO Customer"
                            name="po_customer"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Recommendation"
                            name="recommendation"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea rows={4} placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Payment Type"
                            name="payment_type"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[
                                    { value: "1", label: "Cash" },
                                    { value: "2", label: "Cheque" },
                                    { value: "3", label: "Credit Card" },
                                    { value: "4", label: "Debit Card" },
                                    { value: "5", label: "E-Banking" },
                                    { value: "6", label: "Giro" },
                                    { value: "7", label: "Other" },
                                    { value: "8", label: "Transfer" },
                                    { value: "9", label: "Travel Cheque" },
                                    { value: "10", label: "Voucher" },
                                ]}
                            />
                        </Form.Item>
                        <div className="bill-to">
                            <Form.Item
                                label="Bill To"
                                style={{ marginBottom: "5px" }}
                            >
                                <Checkbox
                                    checked={showContentBillTo}
                                    onChange={(e) => setShowContentBillTo(e.target.checked)}
                                >
                                    Show
                                </Checkbox>
                            </Form.Item>
                            <div style={{ display: showContentBillTo ? "block" : "none" }}>
                                <Form.Item
                                    label="Customer Code"
                                    name="customer_code"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input
                                        placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Customer Type"
                                    name="customer_type"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Title Prefix"
                                    name="title_prefix"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Name"
                                    name="customer_name"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Title Suffix"
                                    name="title_suffix"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="ID Type"
                                    name="id_type"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="ID No"
                                    name="id_no"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Billable To"
                                    name="bill_to"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Address"
                                    name="address_bill"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input.TextArea rows={4} placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Provinsi"
                                    name="provinsi_bill"
                                    style={{ marginBottom: "5px" }}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Pilih Provinsi"
                                        optionFilterProp="label"
                                        onChange={onChangeProvince}
                                        options={provinceOptions}
                                        loading={loadingProvinces}
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        disabled
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Kabupaten"
                                    name="kabupaten_bill"
                                    style={{ marginBottom: "5px" }}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Pilih Kabupaten"
                                        optionFilterProp="label"
                                        onChange={onChangeRegency}
                                        options={regencyOptions}
                                        loading={loadingRegencies}
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        disabled
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Kelurahan"
                                    name="kelurahan_bill"
                                    style={{ marginBottom: "5px" }}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Pilih Kelurahan"
                                        optionFilterProp="label"
                                        onChange={onChangeKelurahan}
                                        options={kelurahanOptions}
                                        loading={loadingKelurahans}
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        disabled
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Kode Pos"
                                    name="kode_pos_bill"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Form.Item
                                    label="Phone No"
                                    name="phone_no_bill"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" />
                                </Form.Item>
                                <Form.Item
                                    label="Terms Of Payment"
                                    name="top"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        options={salesTopOptions}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="tax-list">
                            <Form.Item
                                label="Tax"
                                style={{ marginBottom: "5px" }}
                            >
                                <Checkbox
                                    checked={showContentTaxList}
                                    onChange={(e) => setShowContentTaxList(e.target.checked)}
                                >
                                    Show
                                </Checkbox>
                            </Form.Item>
                            <div style={{ display: showContentTaxList ? "block" : "none" }}>
                                <Form.Item
                                    label="NPWP"
                                    name="npwp"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Input placeholder="" />
                                </Form.Item>
                                <Form.Item
                                    label="Transaction Code"
                                    name="trans_code"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="label"
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        options={vatTransOptions}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Name"
                                    name="name_npwp"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" />
                                </Form.Item>
                                <Form.Item
                                    label="Address"
                                    name="address_npwp"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Input placeholder="" />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="total-list">
                            <Form.Item
                                label="Total"
                                style={{ marginBottom: "5px" }}
                            >
                                <Checkbox
                                    checked={showContentTotal}
                                    onChange={(e) => setShowContentTotal(e.target.checked)}
                                >
                                    Show
                                </Checkbox>
                            </Form.Item>
                            <div style={{ display: showContentTotal ? "block" : "none" }}>
                                <Form.Item
                                    label="Item Total"
                                    name="item_total"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '')}
                                        placeholder=""
                                        readOnly
                                        precision={0}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Item Discount"
                                    name="item_discount"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '')}
                                        placeholder=""
                                        readOnly
                                        precision={0}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Total"
                                    name="total"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '')}
                                        placeholder=""
                                        readOnly
                                        precision={0}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Vat"
                                    name="vat"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '')}
                                        placeholder=""
                                        readOnly
                                        precision={0}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Grand Total"
                                    name="grand_total"
                                    style={{
                                        marginBottom: "5px",
                                    }}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                        parser={(value) => value!.replace(/\./g, '')}
                                        placeholder=""
                                        readOnly
                                        precision={0}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
            <Modal
                title="List Data Work Order"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={1000}
                centered
                destroyOnClose
            >
                <ListDataWorkOrder onRowSelect={handleWorkOrderSelect} />
            </Modal>
            <Modal
                title="Konfirmasi Pembatalan Invoice"
                open={isVoidRemarkVisible}
                onOk={submitVoidWithRemark}
                onCancel={() => setIsVoidRemarkVisible(false)}
                okText="Submit Void"
                cancelText="Batal"
                destroyOnClose
            >
                <p>Masukkan alasan pembatalan:</p>
                <Input.TextArea
                    rows={3}
                    value={voidRemark}
                    onChange={(e) => {
                        const prefix = "Void Invoice";
                        if (e.target.value.startsWith(prefix)) {
                            setVoidRemark(e.target.value);
                        }
                    }}
                    placeholder="Tambah keterangan di sini..."
                />
            </Modal>
            <Modal
                title="Print Preview - Work Order Invoice"
                open={isReportModalOpen}
                onCancel={handleReportModalCancel}
                footer={null}
                width={1100}
                destroyOnClose
            >
                <div id="sti-viewer-container" style={{ width: '100%', minHeight: '75vh' }} />
            </Modal>
            <div className="gjs-grid-row" id="iqb2q">
                <div className="gjs-grid-column" id="ig1ch">
                    <Table<TableListPartInvoice>
                        columns={columns}
                        dataSource={data}
                        bordered
                        size="small"
                        pagination={{ pageSize: 10 }}
                        rowKey="id"
                        rowSelection={{
                            selectedRowKeys,
                            onChange: onSelectChange,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default withWorkOrderInvoice(WorkOrderInvoice);
